import TicketViewerContent from '@/components/manage/tickets/viewer/TicketViewerContent';
import { Typography } from '@/components/primitives/Typography';
import ResponsiveDialog from '@/components/ResponsiveDialog';
import { TransText } from '@/i18n/trans/text';
import type { AdmissionDTO, LegDTO } from '@/types/dto/agent';
import type { CheckoutOrBookingPassengerMap } from '@/types/passenger';
import { type FC } from 'react';

interface TicketViewerModalProps {
  leg: LegDTO;
  admissions: Array<AdmissionDTO>;
  passengersMap: CheckoutOrBookingPassengerMap;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

const TicketViewerModal: FC<TicketViewerModalProps> = ({
  leg,
  admissions,
  passengersMap,
  isOpen,
  onOpenChange,
}) => {
  return (
    <ResponsiveDialog
      open={isOpen}
      onOpenChange={onOpenChange}
      title={
        <Typography variant="subtitle">
          <TransText i18nKey="tickets" />
        </Typography>
      }
      content={
        <TicketViewerContent
          leg={leg}
          admissions={admissions}
          passengersMap={passengersMap}
        />
      }
    />
  );
};

export default TicketViewerModal;
